import { render, staticRenderFns } from "./MRectangle.vue?vue&type=template&id=9c9a10d6&scoped=true"
import script from "./MRectangle.vue?vue&type=script&lang=js"
export * from "./MRectangle.vue?vue&type=script&lang=js"
import style0 from "./MRectangle.vue?vue&type=style&index=0&id=9c9a10d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9a10d6",
  null
  
)

export default component.exports